import { render, staticRenderFns } from "./folder-outline.vue?vue&type=template&id=0ddc1093&"
import script from "./folder-outline.vue?vue&type=script&lang=js&"
export * from "./folder-outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ddc1093')) {
      api.createRecord('0ddc1093', component.options)
    } else {
      api.reload('0ddc1093', component.options)
    }
    module.hot.accept("./folder-outline.vue?vue&type=template&id=0ddc1093&", function () {
      api.rerender('0ddc1093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/folder-outline.vue"
export default component.exports